import modelJson from "./model.json";
import { MenuNodeType } from "./model.types";

export const FALLBACK_MENU: MenuNodeType.Container =
  modelJson as MenuNodeType.Container;

export const FALLBACK_LANGUAGE_NODES: MenuNodeType.Link[] = (
  FALLBACK_MENU!.childNodes!.find(
    (node) => node.titleKey === "Language"
  ) as MenuNodeType.Language
).childNodes;
